import styled from 'styled-components';

import { media } from '@theme/media';
import { COLORS } from '@theme/colors';
import { CONTAINER_PADDING, SIDEBAR_WIDTH } from '@components/blocks';
import { LETTER_SPACING, typography } from '@theme/font';
import { OFFSET } from '@theme/helpers';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 100% 0;
  min-height: 100vh;

  ${media.tablet} {
    grid-template-columns: calc(100% - ${SIDEBAR_WIDTH}px) ${SIDEBAR_WIDTH}px;
  }
`;

export const Content = styled.div``;

export const CardContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 ${CONTAINER_PADDING}px 0;

  ${media.desktop} {
    padding-left: 200px;
  }
`;

export const CardWrapper = styled.div`
  width: 608px;
  max-width: 100%;
`;

export const Card = styled.div<{ cardImage?: string }>`
  width: 100%;
  padding-top: 65%;
  max-width: 100%;
  background-image: ${({ cardImage }) =>
    cardImage
      ? `url("${cardImage}")`
      : `repeating-linear-gradient(to right, ${COLORS.BLACK} 0%, ${COLORS.WHITE} 8.3%, ${COLORS.BLACK} 16.6%)`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  border-radius: 20px;
  position: relative;
`;

export const CardCopyWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
`;

export const CardCopy = styled.div`
  ${typography({ spacing: LETTER_SPACING.S })};
  background-color: ${COLORS.WHITE};
  margin: 0 ${OFFSET.M};
  width: 100%;
  padding: ${OFFSET.XS} ${OFFSET.S};
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  ${media.mobile} {
    flex-direction: row;
  }
`;

export const LeftCopy = styled.div`
  display: flex;
  justify-content: space-between;

  ${media.mobile} {
    flex-direction: row;
  }
`;

export const PlatformCopy = styled.div`
  text-transform: uppercase;

  ${media.mobile} {
    margin-right: 20px;
  }
`;

export const GiftCopy = styled.div``;

export const Amount = styled.div``;

export const MobileActionsWrapper = styled.div`
  display: block;
  position: sticky;
  bottom: 0;
  padding: ${OFFSET.S};
  margin: 0 ${OFFSET.XS} ${OFFSET.XS};
  background-color: ${COLORS.WHITE80};

  ${media.tablet} {
    display: none;
  }
`;
